export var FRAME_INTERVAL = 1000 / 60;
export var ERROR_MARGE_FOR_VIEW_RANGE = 1 / 100;
export var PERCENT_FOR_ANSSI_VALIDATION = 90;
export var PLAYBACK_SPEEDS = [0.25, 0.5, 1, 1.5, 2];
export var DEFAULT_PLAYBACK_SPEED = 1;
